export default {"src":"/_next/static/media/note-orange.4f5dbeee.svg","height":8,"width":44,"blurWidth":0,"blurHeight":0};